import { useState, useEffect } from 'react';
import { api } from '../api';

/**
 * Diz se a conta logada é o dono da plataforma (master), para mostrar ou não o
 * link do painel /admin no menu.
 *
 * Quem decide é o backend (GET /admin/sou-master) — o email master nunca vem
 * para o front. O resultado é guardado em sessionStorage porque não muda
 * durante a sessão (não depende da fazenda ativa) e os dois menus (gaveta e
 * sidebar) consultam o mesmo valor sem repetir a requisição.
 */
const CHAVE = 'sou_master';

export default function useSouMaster() {
  const [isMaster, setIsMaster] = useState(() => sessionStorage.getItem(CHAVE) === 'true');

  useEffect(() => {
    let vivo = true;
    // Já resolvido nesta sessão: não repete a chamada.
    if (sessionStorage.getItem(CHAVE) != null) return;

    api.getSouMaster()
      .then((r) => {
        if (!vivo) return;
        const master = !!r?.master;
        sessionStorage.setItem(CHAVE, String(master));
        setIsMaster(master);
      })
      .catch(() => { /* na dúvida, não mostra o link */ });

    return () => { vivo = false; };
  }, []);

  return isMaster;
}
